export default __webpack_public_path__ + "static/media/ban-desktop-image-1.1f9644e4.jpg";